import { CustomFunction } from "@ceeferenderer/itg-renderer-sdk/model/common";
import { buildValidator } from "./buildValidator";

const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const email: CustomFunction = buildValidator("invalid", (value, input) => {
  const rsRequired = input?.getAttribute("rsrequired");
  const matchWidth = input?.getAttribute("data-match-with");
  if (matchWidth) {
    const matchWithValue = (document.querySelector(`[rsMonitor =${matchWidth}]`) as HTMLInputElement)?.value;
    if (matchWithValue) {
      return typeof value === "string" && emailRegex.test(value.trim()) && value.trim() === matchWithValue.trim();
    } else {
      return true;
    }
  } else {
    if (rsRequired && /\{val:false,/.test(rsRequired) && !value) {
      return true;
    }
    return !!value && typeof value === "string" && emailRegex.test(value.trim());
  }
});
